import { PersonalInformation } from '../../types/PersonalInformation';
import familyStyles from './familyInformationPage.module.scss';
import { isValid, isValidOrEmptyPartner, isValidOrEmptyBarneList } from '../validation';

interface ValidationErrorsProps {
    errorsHovedmedlem: PersonalInformation;
    errorsPartner: PersonalInformation;
    errorsBarn: PersonalInformation[];
}

export function ValidationErrors({ errorsHovedmedlem, errorsPartner, errorsBarn }: ValidationErrorsProps) {
    let errorMessages = [''];

    if (!isValid(errorsHovedmedlem)) {
        errorMessages.push('Hovedmedlem har ugyldige data.');
    }
    if (!isValidOrEmptyPartner(errorsPartner)) {
        errorMessages.push('Ektefelle/samboer har ugyldige data.');
    }
    if (!isValidOrEmptyBarneList) {
        errorMessages.push('Ett eller flere barn har ugyldige data.');
    }

    return (
        <div className={familyStyles.validationBox}>
            {errorMessages.map((message, index) => (
                <div key={index}>{message}</div>
            ))}
        </div>
    );
}
